import { useFormikContext } from "formik";
import React, { FC, useMemo } from "react";
import magicEdenLogo from "../../../../assets/magicEdenLogo.svg";
import solseaLogo from "../../../../assets/solseaLogo.svg";
import unqLogo from "../../../../assets/unqSvgLogo.svg";
import { ProposalBuyOption } from "../../../../common/enums/proposals.enums";
import { IDetailNftData } from "../../../../common/interfaces/common.interface";
import { ICreateProposalForm } from "../../../../common/interfaces/proposals.interface";

const BuyingNftData: FC<{
  nftData: IDetailNftData;
}> = ({ nftData }) => {
  const { values } = useFormikContext<ICreateProposalForm>();

  const getMarketplaceLogo = useMemo(() => {
    switch (values.buyOption) {
      case ProposalBuyOption.MagicEden:
        return magicEdenLogo;
      case ProposalBuyOption.Solsea:
        return solseaLogo;
      case ProposalBuyOption.PeerToPeer:
        return unqLogo;
    }
  }, [values.buyOption]);

  return (
    <div className="buy-nft-proposal__nft-to-buy">
      <div className="buy-nft-proposal__image-name">
        <img
          className="buy-nft-proposal__nft-image"
          src={nftData.nftUrl}
          alt="nft_img"
        />
        <div className="buy-nft-proposal__nft-description">
          <p className="buy-nft-proposal__nft-title">{nftData.name}</p>
          {nftData.collection && (
            <p className="buy-nft-proposal__nft-collection">
              by {nftData.collection.name}
            </p>
          )}
        </div>
      </div>
      {<img className="buy-nft-proposal__logo" src={getMarketplaceLogo} />}
    </div>
  );
};

export default BuyingNftData;
